import React, { MutableRefObject, useState } from 'react'

import { ListingCate } from '@/page-commons/listingBySlug'
import { handleShow } from '@/utils/tracking/eventsHandlers'

import { ModalBase } from '../Modal/ModalBase'

import { RequestType } from '.'

import { RequestContactFeedback } from './requestContactFeedback'
import { RequestContactFlow } from './RequestContactFlow'

type Props = {
  listing: ListingCate
  listingTitle: string
  requestType: RequestType
  similarPropertiesRef: MutableRefObject<HTMLDivElement>
}

export const requestContactModalOptions = {
  desktopWidth: 492,
  overlay: true,
}

export const RequestContactModal: React.FC<Props> = ({
  listing,
  listingTitle,
  requestType = 'visit',
  similarPropertiesRef,
}) => {
  const [feedbackRequestType, setFeedbackRequestType] = useState<RequestType | null>(null)
  return (
    <>
      {feedbackRequestType !== null ? (
        <RequestContactFeedback
          listing={listing}
          listingTitle={listingTitle}
          requestType={feedbackRequestType || requestType}
          similarPropertiesRef={similarPropertiesRef}
        />
      ) : (
        <ModalBase noPadding>
          <RequestContactFlow
            listing={listing}
            requestType={requestType}
            onSuccess={(type) => {
              setFeedbackRequestType(type)
            }}
          />
        </ModalBase>
      )}
    </>
  )
}
